// extracted by mini-css-extract-plugin
export default {"background":"BackgroundElement-RZA0A__background"};